import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { motion, useMotionValue } from "framer-motion";

import Carousel from "@components/Carousel";

import styles from "./CarouselBlock.module.scss";

export default function CarouselBlock({ items }) {
  // One element gets measured to determine the base position and size of elements
  const sizeElRef = useRef();
  const itemWidth = useMotionValue(0);
  const leftEdge = useMotionValue(0);
  useEffect(() => {
    const update = () => {
      const { width: currWidth, left: currLeft } = sizeElRef.current.getBoundingClientRect();
      itemWidth.set(currWidth);
      leftEdge.set(currLeft);
    };
    update();
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("resize", update);
    };
  });

  const [focusedItem, setFocusedItem] = useState(0);
  return (
    <div>
      <div className={styles.grid}>
        <div className={styles.sizer} ref={sizeElRef} />
      </div>

      <Carousel
        className={styles.carousel}
        style={{ paddingLeft: leftEdge }}
        onPositionChange={setFocusedItem}
        items={items.map(({ id, type, src, alt, attribution }) => {
          const props = {
            key: id,
            src: type === "image" ? src + "?fm=webp&w=1920&q=80" : src,
            style: { width: itemWidth },
          };
          let el = null;
          if (type === "image") el = <motion.img {...props} alt={alt} />;
          if (type === "video") el = <motion.video {...props} loop muted playsInline autoPlay />;
          return { el, attribution };
        })}
      />

      <div className={styles.grid}>
        <div className={styles.counter}>
          {(focusedItem + 1).toString().padStart(2, "0")}
          <span className={styles.slash}>/</span>
          {items.length.toString().padStart(2, "0")}
        </div>
      </div>
    </div>
  );
}

CarouselBlock.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(["image", "video"]).isRequired,
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
    }),
  ).isRequired,
};
